import { useEffect, useState } from "react";
import { Header, ScrollProps } from "../../components/Header";

import {
    Container,
    TitlePage,
    ContentHeader,
    ComplementHeader,
    ContentHeaderMobile,
    ResultadosContainer,
    ColunaDireita,
    ColunaEsquerda,
    SortBar,
} from "./styles";

import { CardInfo } from "../../components/CardInfo";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import { LoadSpinner2 } from "../../components/LoadSpinner2";
import { useAuth } from "../../context/auth";
import { GoToTop } from "../../GoToTop";
import { useSearch } from "../../context/search";
import { Footer } from "../../components/Footer";
import { SadAnimation } from "../../components/SadAnimation";
import { LoadSpinnerMoreCards } from "../../components/LoadSpinnerMoreCards";
import { IoMdArrowDropdown } from "react-icons/io";
import MapaImoveis from "../../components/MapaImoveis";
import { OrderByButton } from "../../components/OrderByButton";

export function SearchResult() {
    const { user } = useAuth();
    const [searchParams] = useSearchParams();

    const {
        resetFilters,
        clearSearchResults,
        applySearchFromUrl,
        loading,
        buildings,
        loadingScroll,
        buildingsTotal,
        loadNextPage,
        hasMore,
    } = useSearch();

    const navigate = useNavigate();

    const searchKey = searchParams.toString();

    useEffect(() => {
        applySearchFromUrl(new URLSearchParams(searchKey));
    }, [searchKey, applySearchFromUrl]);

    const backToTheHome = () => {
        resetFilters();
        clearSearchResults();
        navigate('/');
    };

    const [scrollTop, setScrollTop] = useState<ScrollProps>({ y: 0, lastY: 0 } as ScrollProps);
    const [show, setShow] = useState(false);

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const scrollTopVal = event.currentTarget.scrollTop;
        setScrollTop(prevState => ({ y: scrollTopVal, lastY: prevState.y }));
    };

    const imoveisCoords = buildingsTotal
        .map((imovel) => ({
            id: imovel.id,
            id_display: imovel.id_display ? imovel.id_display : imovel.id.toString(),
            descricao: `${imovel.bairro}, ${imovel.cidade}`,
            valor_venda: imovel.valor_venda,
            valor_aluguel: imovel.valor_aluguel,
            latitude: parseFloat(String(imovel.latitude)),
            longitude: parseFloat(String(imovel.longitude)),
            imagens: imovel.arquivos,
            is_venda: imovel.is_venda,
            is_aluguel: imovel.is_aluguel,
        }))
        .filter(
            (imovel) =>
                Number.isFinite(imovel.latitude) &&
                Number.isFinite(imovel.longitude),
        );

    return (
        <Container onScroll={handleScroll}>
            <Header show={show} setShow={setShow} scroll={scrollTop} />
            <ContentHeader>
                <button type="button" onClick={backToTheHome}>
                    <IoChevronBackOutline className="icon" />
                    Voltar
                </button>
                <TitlePage>Resultados da pesquisa</TitlePage>
                <ComplementHeader />
            </ContentHeader>
            <ContentHeaderMobile>
                <div className="content-button-back-home">
                    <button type="button" onClick={backToTheHome}>
                        <IoChevronBackOutline className="icon" />
                        Voltar
                    </button>
                </div>
                <div className="content-title">
                    <h2>Resultados da pesquisa</h2>
                </div>
            </ContentHeaderMobile>

            <ResultadosContainer>
                <ColunaEsquerda>
                    {(loading || buildingsTotal.length > 0) && (
                        <SortBar>
                            <OrderByButton />
                        </SortBar>
                    )}

                    {loading && <LoadSpinner2 />}

                    {!loading && buildingsTotal?.length > 0 && (
                        <div className="content-search-map">
                            {buildingsTotal.map((b) => (
                                <CardInfo
                                    id={b.id}
                                    id_display={b.id_display}
                                    key={b.id}
                                    descricao={b.descricao}
                                    valor_aluguel={b.is_aluguel}
                                    is_aluguel={b.is_aluguel}
                                    is_venda={b.is_venda}
                                    latitude={b.latitude}
                                    longitude={b.longitude}
                                    periodo_aluguel={b.periodo_aluguel}
                                    valor_venda={b.valor_venda}
                                    arquivos={b.arquivos}
                                    onClick={() =>
                                        navigate(
                                            user
                                                ? `/perfil/${user.id_corretor}/imovel/${b.id}`
                                                : `/imovel/${b.id}`,
                                        )
                                    }
                                    idBuilding={b.id}
                                    is_fixado={b.is_fixado}
                                    is_destaque={b.is_destaque_corretor}
                                    is_lancamento={b.is_lancamento}
                                    is_condominio={b.is_condominio}
                                    bairro={b.bairro}
                                    cidade={b.cidade}
                                    ap_bloco={b.ap_bloco}
                                    ap_numero={b.ap_numero}
                                />
                            ))}
                        </div>
                    )}

                    {!loading && buildingsTotal?.length === 0 && (
                        <div className="no-result">
                            <SadAnimation />
                            <p>Nenhum item encontrado em sua busca.</p>
                        </div>
                    )}
                </ColunaEsquerda>
                <ColunaDireita>
                    <MapaImoveis imoveis={imoveisCoords} />
                </ColunaDireita>
            </ResultadosContainer>

            {buildingsTotal?.length > 0 && (
                <>
                    {loadingScroll && <LoadSpinnerMoreCards />}
                    <div className="div-content-button-view-more">
                        <button
                            type="button"
                            disabled={!hasMore || buildings.length < 12}
                            className="view-more"
                            onClick={loadNextPage}
                        >
                            Ver mais <IoMdArrowDropdown className="arrow-view-more" />
                        </button>
                    </div>
                </>
            )}

            <GoToTop />
            <Footer />
        </Container>
    );
}
